import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const NotificationsPage = lazyPage(() => import("./pages/NotificationsPage"), "NotificationsPage");

export const notificationsModule: WebModule = {
  id: "notifications",
  nav: null,
  routes: [{ path: "/notifications", element: <NotificationsPage /> }],
  publicRoutes: [],
};
